import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { capitalizeWords } from "../../utils/helpers";

const Legends = ({ legends, sx = {} }) => {
  const classes = useStyles();
  return (
    <Box sx={sx}>
      {legends.map((data) => (
        <Box className={classes.root}>
          <Box
            className={classes.legend}
            sx={{ background: data.color || data.fill }}
          ></Box>
          <Typography>{capitalizeWords(data.label || data.name)}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default Legends;

const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: "flex",
      alignItems: "center",
      gridGap: "8px",
      margin: "12px 5px",
      "& p": {
        fontSize: "12px",
      },
    },
    legend: {
      height: "12px",
      width: "12px",
      borderRadius: "50%",
    },
  };
});
